import React from 'react'
import FAQ from 'src/app/FAQ/FAQ'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { faqRouteProps } from 'src/navigation/routeProps'

const FAQAppRoute: AppRoute = {
  routeProps: faqRouteProps,
  component: <FAQ />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default FAQAppRoute
